import request from './request'

// ============ 登录 ============
export function adminLogin(data) {
  return request.post('/admin/login', data)
}

// ============ 修改密码 ============
export function changePassword(data) {
  return request.post('/admin/change-password', data)
}

// ============ 当前登录管理员（头像/账号/昵称/角色） ============
export function getAdminProfile() {
  return request.get('/admin/profile')
}
// 修改本人资料：只能改昵称与头像
export function updateAdminProfile(data) {
  return request.put('/admin/profile', data)
}

// ============ 账号管理（仅超级管理员） ============
export function getAdminUserList(params) {
  return request.get('/admin/adminUser/list', { params })
}
export function createAdminUser(data) {
  return request.post('/admin/adminUser', data)
}
export function updateAdminUser(id, data) {
  return request.put('/admin/adminUser/' + id, data)
}
export function deleteAdminUser(id) {
  return request.delete('/admin/adminUser/' + id)
}

// ============ 数据看板 ============
export function getDashboardStats() {
  return request.get('/admin/dashboard/stats')
}

// ============ 商品 ============
export function getProductList(params) {
  return request.get('/admin/product/list', { params })
}
export function getProductStats() {
  return request.get('/admin/product/stats')
}
export function createProduct(data) {
  return request.post('/admin/product', data)
}
export function updateProduct(id, data) {
  return request.put('/admin/product/' + id, data)
}
export function deleteProduct(id) {
  return request.delete('/admin/product/' + id)
}

// ============ 分类 ============
export function getCategoryList(params) {
  return request.get('/admin/category', { params })
}
export function createCategory(data) {
  return request.post('/admin/category', data)
}
export function updateCategory(id, data) {
  return request.put('/admin/category/' + id, data)
}
export function deleteCategory(id) {
  return request.delete('/admin/category/' + id)
}

// ============ 轮播 ============
export function getBannerList(params) {
  return request.get('/admin/banner', { params })
}
export function createBanner(data) {
  return request.post('/admin/banner', data)
}
export function updateBanner(id, data) {
  return request.put('/admin/banner/' + id, data)
}
export function deleteBanner(id) {
  return request.delete('/admin/banner/' + id)
}

// ============ 优惠券 ============
export function getCouponList(params) {
  return request.get('/admin/coupon', { params })
}
export function createCoupon(data) {
  return request.post('/admin/coupon', data)
}
export function updateCoupon(id, data) {
  return request.put('/admin/coupon/' + id, data)
}
export function deleteCoupon(id) {
  return request.delete('/admin/coupon/' + id)
}

// ============ 配送政策（模板 + 批量套用）============
export function getShippingPolicies() {
  return request.get('/admin/shippingPolicy')
}
export function saveShippingPolicy(data) {
  return request.post('/admin/shippingPolicy', data)
}
export function deleteShippingPolicy(id) {
  return request.delete('/admin/shippingPolicy/' + id)
}
// 把某个模板设为全店默认模板（有且仅有一个，商品未配配送政策时按它兜底计费）
export function setDefaultShippingPolicy(id) {
  return request.post('/admin/shippingPolicy/' + id + '/default')
}
export function batchSetProductPolicy(data) {
  return request.post('/admin/product/batchPolicy', data)
}

// ============ 订单 ============
export function getOrderList(params) {
  return request.get('/admin/order/list', { params })
}
export function getOrderStats() {
  return request.get('/admin/order/stats')
}
export function getOrderDetail(id) {
  return request.get('/admin/order/detail/' + id)
}
export function deliverOrder(data) {
  return request.post('/admin/order/deliver', data)
}
// 查询订单实时物流轨迹
export function getOrderLogistics(id) {
  return request.get('/admin/order/' + id + '/logistics')
}
// 查询订单地图轨迹（返回 trailUrl 地图轨迹页 + 路由节点经纬度）
export function getOrderMapTrack(id) {
  return request.get('/admin/order/' + id + '/logistics/map')
}
// 根据快递单号自动识别快递公司
export function detectExpressCompany(number) {
  return request.get('/admin/logistics/detect', { params: { number } })
}
export function refundOrder(id) {
  return request.post('/admin/order/refund/' + id)
}

// ============ 售后管理（仅退款/退货退款/换货/补发）============
export function getAfterSaleList(params) {
  return request.get('/admin/afterSale/list', { params })
}
export function getAfterSaleStats() {
  return request.get('/admin/afterSale/stats')
}
export function getAfterSaleDetail(id) {
  return request.get('/admin/afterSale/detail/' + id)
}
// action: agree | reject | confirmReturn | reship
export function handleAfterSale(data) {
  return request.post('/admin/afterSale/handle', data)
}

// ============ 用户 ============
export function getUserList(params) {
  return request.get('/admin/user/list', { params })
}

export function getUserDetail(id) {
  return request.get(`/admin/user/detail/${id}`)
}
// 用户统计（页面顶部统计卡片）
export function getUserStats() {
  return request.get('/admin/user/stats')
}
// 手动调整用户余额(type=1)/积分(type=2)，amount 可正可负
export function adjustUserAccount(data) {
  return request.post('/admin/user/adjust', data)
}

// ============ 评价管理 ============
export function commentList(params) {
  return request.get('/admin/comment/list', { params })
}
export function commentStats() {
  return request.get('/admin/comment/stats')
}
export function commentReply(data) {
  return request.post('/admin/comment/reply', data)
}
export function commentDelete(id) {
  return request.delete('/admin/comment/' + id)
}

// ============ 支付管理 ============
export function getPayConfig() {
  return request.get('/admin/pay/config')
}
export function savePayConfig(data) {
  return request.post('/admin/pay/config', data)
}
export function getPayStats() {
  return request.get('/admin/pay/stats')
}
export function getPayRecords(params) {
  return request.get('/admin/pay/records', { params })
}

// ============ 系统设置（客服） ============
export function getSystemConfig() {
  return request.get('/admin/config')
}
export function saveSystemConfig(data) {
  return request.post('/admin/config', data)
}
// 公开配置（无需登录）：/config，管理后台据此显示系统名称/Logo/网站图标
export function getPublicConfig() {
  return request.get('/config')
}

// ============ 上传 ============
export function uploadImage(formData) {
  return request.post('/admin/upload', formData)
}
// 清理已上传但未保存的图片（弹窗取消时调用；后端仅删除全库无引用的）
export function cleanupUploads(urls) {
  return request.post('/admin/upload/cleanup', { urls })
}
